import { Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import { DRUCKPFAHL, ZUGPFAHL } from "../../../constants";
import KiloNewton from "../../Math/Units/Metric/KiloNewton";
import Millimetre from "../../Math/Units/Metric/Millimetre";
import { DataRow, DataRowTextValue } from "../DataRow";
import { styles, tableStyles } from "../SmartTitanProjektPDF";

export function GermanyPfahlkopfHead({ data }) {
  const { t } = useTranslation("translation");
  const isGermany = data.Deckblatt.BemessungenMikropfaehle === 1;
  const isTension =
    data.Germany.Innere.BeanspruchungausStatik.belastungsartUndRichtung === ZUGPFAHL;
  let itemIndex = 1;
  return (
    <View>
      {/* Pfahlkopf / Übergangsrohr */}
      <Text style={styles.section}>{t("navigation.pileHeadConstruction")}</Text>

      {isGermany ? (
        <Text style={styles.sectionSubText}>{t("aeussre.nationalTechnicalApprovalText")}</Text>
      ) : null}
      <Text style={styles.sectionSubText2}>{t("aeussre.additionalText")}</Text>

      <View style={tableStyles.tableContainer}>
        {/* Belastungsart/-Richtung */}
        <DataRowTextValue
          item={{
            title: t("aeussre.loadType"),
            value: t(
              data.Germany.PileHeadConstruction.belastungsartUndRichtung === DRUCKPFAHL
                ? "inner.compressionPile"
                : "inner.tensionPile"
            ),
            itemIndex: itemIndex++,
          }}
        />

        {/* Werkstoff Übergangsrohr */}
        <DataRowTextValue
          item={{
            title: t("aeussre.transitionTubeMaterial"),
            value: t(
              data.Germany.PileHeadConstruction.werkstoffUebergangsrohr === 0 || isTension
                ? "aeussre.plasticTube"
                : "aeussre.steelTube"
            ),
            itemIndex: itemIndex++,
          }}
        />

        {/* Bemessungslast */}
        <DataRow
          item={{
            title: t("aeussre.designLoad"),
            value: data.Germany.PileHeadConstruction.bemessungslast,
            // F_{d}
            // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}F_{d}
            // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}F_{d}
            bezImage: {
              uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}F_{d}",
              height: 7,
              width: 10,
            },
            valueScale: 2,
            itemIndex: itemIndex++,
            valueUnit: <KiloNewton />,
          }}
        />

        {/*Stahltragglied */}
        <DataRowTextValue
          item={{
            title: t("aeussre.LoadCarryingElement"),
            value: data.Germany.PileHeadConstruction.wahlDesStahltraggliedes,
            itemIndex: itemIndex++,
          }}
        />

        {/* Durchmesser Stahltragglied */}
        <DataRow
          item={{
            title: t("inner.verificationCapacity.hollowBarDiameter"),
            value: data.Germany.PileHeadConstruction.durchmesserStahltragglied,
            bezImage: {
              uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}D_a",
              height: 7,
              width: 10,
            },
            valueScale: 2,
            itemIndex: itemIndex++,
            valueUnit: <Millimetre />,
          }}
        />

        {/* Erforderliche Zementsteinüberdeckung */}
        <DataRow
          item={{
            title: t("inner.verificationCapacity.requiredGroutCover"),
            bezImage: {
              uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}c_{req}",
              height: 9,
              width: 15,
            },
            value: data.Germany.PileHeadConstruction.vorhandeneZementsteinueberdeckung,
            valueScale: 0,
            itemIndex: itemIndex++,
            valueUnit: <Millimetre />,
          }}
        />
      </View>
    </View>
  );
}
